import { Box, Flex, Heading, HStack, PinInput, PinInputField, Spacer, Stack, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useState } from 'react';
import { IServerResponse } from '../../common/types/socket';
import { ChatComponent } from './Chat';
import { Error } from './Error';
import { useApi } from './hooks/Api';
import { useAppState } from './hooks/AppState';

export const App = observer(() => {
    const [value, setValue] = useState('');
    const [status, setStatus] = useState<'idle' | 'sending' | 'error'>('idle');
    const api = useApi();
    const appState = useAppState();

    const valueChanged = useCallback(
        async (value: string) => {
            setStatus('idle');
            setValue(value);
            if (value.length === 6) {
                setStatus('sending');
                api.code = parseInt(value);
                const response = (await api.post('/status')).data as IServerResponse<any>;

                if (response.type === 'login_failure') {
                    console.log('Login failed');
                    setStatus('error');
                } else {
                    appState.setAppState(response.content);
                    localStorage.setItem('code', value);
                    setValue('');
                    setStatus('idle');
                }
            }
        },
        [api, appState],
    );

    useEffect(() => {
        const stored = localStorage.getItem('code');

        if (stored) {
            valueChanged(stored);
        }
    }, [valueChanged]);

    if (appState.appState) {
        return <ChatComponent />;
    }

    return (
        <Flex minH={'100vh'} align={'center'} justify={'center'} bg="gray.800" color="gray.200">
            {appState.serverOnline ? (
                <Stack spacing={8} mx={'auto'} w={'lg'} py={12} px={6}>
                    <Stack align={'center'}>
                        <Heading fontSize={'4xl'}>Přihlášení týmu</Heading>
                        <Text fontSize={'lg'} color={'gray.500'}>
                            Pro přihlášení zadejte kód ze startovní obálky
                        </Text>
                    </Stack>
                    <Box rounded={'lg'} bg={'gray.700'} boxShadow={'lg'} p={8}>
                        <HStack alignContent="center" my={4}>
                            <Spacer />
                            <PinInput
                                size="lg"
                                errorBorderColor="red.500"
                                isInvalid={status === 'error'}
                                isDisabled={status === 'sending'}
                                value={value}
                                onChange={valueChanged}
                            >
                                <PinInputField />
                                <PinInputField />
                                <PinInputField />
                                <PinInputField />
                                <PinInputField />
                                <PinInputField />
                            </PinInput>
                            <Spacer />
                        </HStack>
                    </Box>
                </Stack>
            ) : (
                <Error />
            )}
        </Flex>
    );
});
